module.exports = __webpack_public_path__ + "img/shop1.95fbcbe8.png";